module.exports = __webpack_public_path__ + "static/AssistBgBig-6cf57b8effc8274262b45c65870aeda1.png";